// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1M-98","legacyBtn":"MutateMid_legacyBtn__1SXj-"};